import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingListInformationComponent } from './waiting-list-information.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { AirportNamePipeModule } from '../../pipes/airport-name/airport-name.module';

@NgModule({
  declarations: [WaitingListInformationComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule, AirportNamePipeModule],
  exports: [WaitingListInformationComponent],
})
export class WaitingListInformationModule {}
